module.exports = __webpack_public_path__ + "static/media/tweetme.af1f1833.JPG";